module.exports = __webpack_public_path__ + "media/images/copy-b04b6479.svg";